/**
 * WorldEnvironment registration: the parser and the property formatter.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseWorldEnvironment } from './parser';
import { formatWorldEnvironmentProperties } from './propertyFormatter';
const worldEnvironmentRegistration = {
    typeName: 'WorldEnvironment',
    parser: parseWorldEnvironment,
    propertyFormatter: formatWorldEnvironmentProperties,
};
nodeRegistry.register(worldEnvironmentRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map